import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';
import Select from "react-select";

export class EditionCopyForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            originalEndDate: this.props.value.endDate
        };
    }

    renderHelpBlock(inputError, message) {
        if (null === inputError) {
            return null;
        }

        return (<HelpBlock>{message}</HelpBlock>);
    }

    renderNameFormControl(value) {
        return (
            <FormControl
                type="text"
                value={value.name}
                placeholder="Introduza o Nome"
                onChange={(a) => this.props.onChangeValue(a, "name")}
            />
        );
    }

    renderNetworkEditionFormControl(value) {
        const { dependencies } = this.props;

        return (
            <Select
                className="custom-multiselect"
                placeholder="Selecione uma edição..."
                noOptionsMessage={() => "Sem Edições Configuradas"}
                onChange={(e) => this.props.onSelectValue(null === e ? 0 : e.id, "networkEditionId")}
                options={dependencies.networkEditions}
                isMulti={false}
                isClearable={true}
                getOptionValue={value => value.id}
                getOptionLabel={label => label.name}
                value={dependencies.networkEditions.find(nEdition => nEdition.id === value.networkEditionId)}
            />
        )
    }

    renderNetworkEditionFormGroup(type, value, editionInputError, editionErrorMessage) {
        if ("planning" !== type) {
            return;
        }

        return (
            <FormGroup controlId="formNetworkEdition" validationState={editionInputError}>
                <ControlLabel>Edição de Rede</ControlLabel>
                {this.renderNetworkEditionFormControl(value)}
                {this.renderHelpBlock(editionInputError, editionErrorMessage)}
            </FormGroup>
        );
    }

    render() {
        const { type, value, nameInputError, editionInputError, nameErrorMessage, editionErrorMessage } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Copiar</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={nameInputError} >
                            <ControlLabel>Nome</ControlLabel>
                            {this.renderNameFormControl(value)}
                            {this.renderHelpBlock(nameInputError, nameErrorMessage)}
                        </FormGroup>

                        {this.renderNetworkEditionFormGroup(type, value, editionInputError, editionErrorMessage)}
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={this.props.onSave}> COPIAR </Button>
                        <Button onClick={this.props.onHide}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/editions/forms/EditionCopyForm.js